import { FaxStatus, FaxStatusFields } from './fax-test-section.types';

// Helper function to get status color
export const getStatusColor = (status: string): string => {
  const upperStatus = status?.toUpperCase() || '';
  if (upperStatus === 'DELIVERED') return '#28a745'; // green
  if (upperStatus === 'RECEIVED') return '#17a2b8'; // teal/cyan - different from delivered
  if (upperStatus === 'SENT') return '#ffc107'; // yellow/orange
  if (upperStatus === 'FAILED' || upperStatus === 'ERROR' || upperStatus === 'FAILED_RETRYABLE') return '#dc3545'; // red
  if (upperStatus === 'RETRYING') return '#fd7e14'; // orange
  return '#6c757d'; // gray for unknown
};

export const getStatusBgColor = (status: string): string => {
  const upperStatus = status?.toUpperCase() || '';
  if (upperStatus === 'DELIVERED') return '#d4edda'; // light green
  if (upperStatus === 'RECEIVED') return '#d1ecf1'; // light teal/cyan
  if (upperStatus === 'SENT') return '#fff3cd'; // light yellow
  if (upperStatus === 'FAILED' || upperStatus === 'ERROR' || upperStatus === 'FAILED_RETRYABLE') return '#f8d7da'; // light red
  if (upperStatus === 'RETRYING') return '#ffe5d0'; // light orange
  return '#e2e3e5'; // light gray for unknown
};

// Helper to extract field values from fax status response
export const getFaxStatusFields = (faxStatus: FaxStatus | null): FaxStatusFields => {
  const getFromValue = () => {
    if (!faxStatus) return 'N/A';
    return faxStatus.locationPhone || faxStatus.locationFaxPhone ||
           faxStatus.LocationFaxPhone || faxStatus.fromDid ||
           faxStatus.FromDID || faxStatus.from || 'N/A';
  };

  const getToValue = () => {
    if (!faxStatus) return 'N/A';
    return faxStatus.contactPhone || faxStatus.contactFaxPhone ||
           faxStatus.ContactFaxPhone || faxStatus.toDid ||
           faxStatus.ToDID || faxStatus.to || 'N/A';
  };

  const getStatusValue = () => {
    if (!faxStatus) return 'N/A';
    return faxStatus.status || faxStatus.Status || 'N/A';
  };

  const getDirectionValue = () => {
    if (!faxStatus) return 'N/A';
    return faxStatus.direction || faxStatus.Direction || 'N/A';
  };

  const getCreatedAtValue = () => {
    if (!faxStatus) return undefined;
    return faxStatus.createdAt || faxStatus.CreatedAt || faxStatus.created_at;
  };

  return {
    from: getFromValue(),
    to: getToValue(),
    status: getStatusValue(),
    direction: getDirectionValue(),
    createdAt: getCreatedAtValue(),
  };
};
